<app-header></app-header>

<br />
<section id="faq" class="faq section-bg">
    <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="row">
            <h1 class="text-primary text-center">Frequently Asked Questions</h1>
            <div class="col-12 col-md-6 px-md-5">
                <div class="text-center">
                    <img src="assets/icons/car-icon.png" alt="FAQ Icon" class="faq-icon" style="max-width: 100px" />
                    <br />
                    <br />
                </div>
                <h3 class="mb-3">I am a driver who needs parking</h3>
                <div class="faq-list">
                    <ul>
                        <ng-container *ngFor="let faq of clientFaqs; let i = index">
                            <li data-aos="fade-up" data-aos-delay="200" class="card aos-init aos-animate">
                                <i class="bx bx-help-circle icon-help"></i>
                                <a data-bs-toggle="collapse" [attr.data-bs-target]="'#client-faq-list-' + i" class="collapsed">
                                    {{ faq.question }}

                                    <i class="bx bx-chevron-down icon-show"></i>

                                    <i class="bx bx-chevron-up icon-close"></i>
                                </a>
                                <div id="client-faq-list-{{ i }}" class="collapse" data-bs-parent=".client-faq-list">
                                    <p [innerHTML]="faq.answer | safe: 'html'"></p>
                                </div>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>

            <div class="col-12 col-md-6 px-md-5">
                <div class="text-center">
                    <img src="assets/icons/building-icon.png" alt="FAQ Icon" class="faq-icon" style="max-width: 100px" />
                    <br />
                    <br />
                </div>
                <h3 class="mb-3">I am a Property owner who wants to list</h3>
                <div class="faq-list">
                    <ul>
                        <ng-container *ngFor="let faq of merchantFaqs; let i = index">
                            <li data-aos="fade-up" data-aos-delay="200" class="card aos-init aos-animate">
                                <i class="bx bx-help-circle icon-help"></i>
                                <a data-bs-toggle="collapse" [attr.data-bs-target]="'#merchant-faq-list-' + i" class="collapsed">
                                    {{ faq.question }}

                                    <i class="bx bx-chevron-down icon-show"></i>

                                    <i class="bx bx-chevron-up icon-close"></i>
                                </a>
                                <div id="merchant-faq-list-{{ i }}" class="collapse" data-bs-parent=".merchant-faq-list">
                                    <p [innerHTML]="faq.answer | safe: 'html'"></p>
                                </div>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<app-footer></app-footer>
